import { ADMIN_AUTH_KEY } from "@constants";
import { IAdmin } from "@interfaces/admin";
import { useTranslation } from "react-i18next";
import { useLocalStorage } from "react-use";

const Dashboard = () => {
  const { t } = useTranslation();
  const [admin] = useLocalStorage<IAdmin>(ADMIN_AUTH_KEY);
  return (
    <div className="text-center py-10">
      <img className="m-auto max-w-[500px]" src="/images/welcome.png" alt="Dashboard" />
      <h1 className="text-3xl mb-3">{t("common:haveAGoodDay")} <span className="text-blue-500">{admin?.name}</span></h1>
      <p className="m-auto max-w-[500px]">{t("common:dashboardWelcome")}</p>
    </div>
  );
};

export default Dashboard;
